import React from 'react';
import styled from 'styled-components';
import { SelectIcon } from '../../../components/Icon';

type Props = {
  isAltStyle?: boolean;
  isBracketOption?: boolean;
};

const StyledSelectIconWrapper = styled.div<{
  isAltStyle: boolean;
  isBracketOption?: boolean;
}>`
  width: 16px;
  position: absolute;
  left: 10px;

  ${({ isAltStyle }) => {
    if (isAltStyle) {
      return `bottom: 8px;`;
    }
    return `top: 12px;`;
  }};

  @media (max-width: 767px) {
    top: 8px;
    left: 8px;
    ${({ isBracketOption }) => {
    if (isBracketOption) {
      return `left: 5px !important;
      width: 14px !important;
      top: 9px !important;`;
    }
  }}
  }
`;

export const SelectedIcon = ({ isAltStyle = false, isBracketOption }: Props) => {
  return (
    <StyledSelectIconWrapper isAltStyle={isAltStyle} isBracketOption={isBracketOption}>
      <SelectIcon />
    </StyledSelectIconWrapper>
  );
};
